<template>
    <div v-if="isSidebarCollapsed || userId != null" class="chat__header">
        <vs-navbar class="p-4 flex navbar-custom" color="white" type="flat">
            <div class="relative flex mr-4">
                <feather-icon icon="MenuIcon" class="mr-4 cursor-pointer" v-if="isSidebarCollapsed" @click.stop="$emit('openContactsSidebar')" />
                <vs-avatar v-if="userId != null" class="m-0 border-2 border-solid border-white" size="40px" :src="userDetails.image" @click.stop="viewProfile(userId)" />
            </div>
            <h6 v-if="userId != null" class="cursor-pointer" @click.stop="viewProfile(userId)">{{ userDetails.name }}</h6>
            <vs-spacer></vs-spacer>
<!--            <feather-icon icon="StarIcon" class="cursor-pointer" :svgClasses="[{'text-warning stroke-current': isPinnedLocal}, 'w-6', 'h-6']" @click.stop="isPinnedLocal = !isPinnedLocal"></feather-icon>-->
        </vs-navbar>
    </div>
</template>

<script>
export default {
  props: {
    userId: {
      required: true,
    },
    isPinnedProp: {
      type: Boolean,
      required: true,
    },
    isSidebarCollapsed: {
      type: Boolean,
      required: true,
    }
  },
  computed: {
    isPinnedLocal: {
      get() {
        return this.isPinnedProp
      },
      set(val) {
        const chatData = this.$store.getters['chat/chatDataOfUser'](this.userId);
        if (chatData) {
          const payload = { id: this.userId, value: val };
          this.$store.dispatch('chat/toggleIsPinned', payload)
            .then(() => { this.$emit('toggleIsChatPinned', val) })
        } else {
          this.$emit('toggleIsChatPinned', val)
        }
      }
    },
    userDetails() {
      return this.$store.getters['chat/contact'](this.userId)
    },
  }
}

</script>

